export class LayerListTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        layers: "Lager",
        legendInfo: "Teckenförklaring",
        opacity: "Opacitet",
        nolayers: "Det finns inga lager att visa"
    };
}
